// test1299
(1299 && 0);
